import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import Box from '@mui/material/Box';
import { Dayjs } from 'dayjs';

interface DateSelectProps {
  birthDate: Dayjs | null;
  setBirthDate: (date: Dayjs | null) => void;
  dateFormat: string;
}

const DateSelect = ({ birthDate, setBirthDate, dateFormat }: DateSelectProps) => {
  
  const userDateFormat = (dateFormat || 'YYYY/MM/DD').toUpperCase();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          overflow: 'visible',
          paddingTop: '0px',
        }}
      >
        <DatePicker
          value={birthDate}
          onChange={(newValue) => setBirthDate(newValue)}
          slotProps={{ textField: { size: 'small' } }}
          format={userDateFormat}

        />
      </Box>
    </LocalizationProvider>
  );
};

export default DateSelect;
